import React from 'react';
import config from '../../../config';
import _ from 'lodash';
import { piece_block_info, sortFloors } from '../../../helpers';

class Pieces extends React.Component {
    state = {
        toggle: 0,
        rooms_selected: [],
        assigned_tasks: [],
        floors: [],
        status: config.room_status,
        pieces_taken: null
    }

    componentWillReceiveProps = nextProps => {
        const { bookings, room, book } = nextProps;
        if (bookings) {
            this.setState({
                pieces_taken: [..._.chain(bookings)
                    .reject(b => b.SAME_DAY) // Exclude bookings that checksout the same day
                    .map(b => b.Rooms || [])
                    .flattenDeep()
                    .filter(r => r.IdPiece)
                    .map(p => p.IdPiece)
                    .value(),
                ..._.chain(book.Rooms) // Also exclude pieces alreadi assigned to this booking
                    .filter(r => r.IdPiece)
                    .map(p => p.IdPiece)
                    .value()]
            });
        }
    }

    onFreePiece = () => {
        this.props.fnFree && this.props.fnFree();
    }
    render() {
        const { floors, room } = this.props, { status, toggle, pieces_taken } = this.state;
        return <section>
            {room?.IdPiece && <div className="d-flex bg-gray-2 px-4 d-flex black-input mb-3 mt-4 mx-4 " style={{ overflow: 'hidden' }}>
                <h1 className="white">Actual: {room.PieceLabel}</h1>
                <button className="ms-auto red" onClick={this.onFreePiece}><i className="fas fa-times me-2" />Liberar</button>
            </div>}
            <div className="bg-gray-2 d-flex black-input mb-3 mt-4 mx-4" style={{ overflow: 'hidden' }}>
                <div className="w-100">

                    {floors && floors.length > 0 && sortFloors(floors).map((floor, floor_index) => {
                        return (<section key={floor.IdFloor || floor.TemporalId}>

                            {/* FLOOR HEADER */}
                            <div className="px-4 py-3 d-flex pointer" onClick={() => this.setState({ toggle: floor_index }, () => {
                                // NEW: if we change floors, we clean up the selection and the status
                                const { status } = this.state;
                                status.forEach(s => s.selected = false);
                                this.setState({ status, rooms_selected: [] });
                            })}>
                                <span className="poppins white align-self-center">Piso {floor.Label}</span>
                                {/*<i className={`ms-2 blue fas fa-chevron-${toggle === floor_index ? 'down' : 'right'} align-self-center`} />*/}
                            </div>

                            {/* PIECES */}
                            {pieces_taken && <div className="bg-black p-4 d-flex flex-wrap justify-content-center">

                                {_.chain(floor.Pieces)
                                    .filter((piece, i) => {
                                        if (this.state.filter_assigned_tasks) {
                                            return _.find(piece.Staff, s => s.IdStaff === user.IdStaff) ? true : false
                                        }
                                        return true;
                                    })
                                    .value().map((piece, b) => {

                                        // If the piece is already taken for the day, we mark it as 
                                        //'Ocupada (4)', so It cannot be selected. If not, we set it 
                                        // to 'Disponible (3)' 
                                        const { pieces_taken, status } = this.state, { room, book } = this.props;
                                        let current_status = piece.Status + 0;
                                        let ocupada = _.find(status, s => s.id === 4);
                                        if (_.find(pieces_taken, p => p === piece.IdPiece) && !(current_status & ocupada.pow)) {
                                            current_status += ocupada.pow;
                                        }

                                        // Fuera de servicio: se evalua contra el check-in de la reserva, asi una
                                        // pieza cuyo bloqueo vence antes de la llegada si se puede asignar
                                        const block = piece_block_info(piece, book?.CheckIn);
                                        const out_of_service = block ? block.blocked : false;
                                        //

                                        const unavailable = (current_status & ocupada.pow) || out_of_service || (room && piece.IdRoom !== room.IdRoom);

                                        return <figure className={`pointer bg-gray-2 d-flex flex-column black-input m-1 p-2 ${_.find(this.state.rooms_selected, r => r.IdPiece === piece.IdPiece) ? 'white-border' : ''}`} style={{ width: 200, opacity: unavailable ? 0.3 : 1 }} key={b} onClick={() => {
                                            // Click handler
                                            if (out_of_service) {
                                                alert(`Habitacion fuera de servicio${block.reason ? `: ${block.reason}` : ''}.${block.until_label ? ` Disponible a partir del ${block.until.clone().add(1, 'day').format('DD/MM/YYYY')}.` : ''}`);
                                            } else if (unavailable) {
                                                // TODO: alert that is taken
                                                alert('Habitacion no disponible para esta reserva');
                                            } else
                                                this.props.fn && this.props.fn(piece);
                                        }}>
                                            <div className="d-flex w-100">

                                                {/* VER */}
                                                <div className="d-flex" onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    this.setState({ watch_room: piece, seeing: true }, () => {
                                                        this.props.floors_actions.fetch_comments(this.state.watch_room.IdPiece);
                                                    });
                                                }} >
                                                    <i className="fas fa-eye white font-10 align-self-center"></i>
                                                    <span className="white font-10 align-self-center ms-1 poppins">Ver</span>
                                                </div>

                                                {/* SELECTED */}
                                                <i className={`ms-auto ${_.find(this.state.rooms_selected, r => r.IdPiece === piece.IdPiece) ? 'fas fa-circle green' : 'far fa-circle white'} font-10 align-self-center ms-1`}></i>
                                            </div>

                                            {/* LABEL */}
                                            <div className="d-flex w-100 justify-content-center" style={{ height: 30 }}>
                                                <span className="white font-10 align-self-center mx-2 poppins">{piece.Label}</span>
                                            </div>

                                            {/* FUERA DE SERVICIO */}
                                            {out_of_service && <div className="d-flex flex-column w-100 mb-1">
                                                <span className="red font-8 poppins line1"><i className="fas fa-warning me-1" />Fuera de servicio</span>
                                                {block.reason && <span className="gray font-8 poppins line1">{block.reason}</span>}
                                                {block.until_label && <span className="gray font-8 poppins line1">Hasta {block.until_label}</span>}
                                            </div>}

                                            {/* STATUS */}
                                            <div className="d-flex w-100">
                                                {status.map((s, index) => {
                                                    if (current_status & s.pow) {
                                                        return (<i key={index} className="me-1 fas fa-circle font-10 align-self-center" title={s.name} style={{ color: s.color }}></i>)
                                                    } else return null
                                                })}
                                                <span className="white font-10 align-self-center ms-1 poppins">Estados</span>
                                            </div>
                                        </figure>
                                    })}
                            </div>}
                        </section>)
                    })}
                </div>
            </div>
        </section>
    }
}

export default Pieces;